/* OsManager.icon.svg.js */

'use strict';
module.exports = {
    icon: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 559 768">
    <title></title>
    <path class="foreground-gl" d="M279.273 174.545v104.727l139.637-139.636-139.637-139.636v104.727c-154.298 0-279.273 124.975-279.273 279.273 0 54.807 16.058 105.775 43.287 148.713l50.967-50.967c-15.709-28.975-24.436-62.487-24.436-97.745 0-115.549 93.905-209.455 209.455-209.455zM515.258 235.287l-50.967 50.967c15.36 29.324 24.436 62.487 24.436 97.745 0 115.549-93.905 209.455-209.455 209.455v-104.727l-139.636 139.636 139.636 139.636v-104.727c154.298 0 279.273-124.975 279.273-279.273 0-54.807-16.058-105.775-43.287-148.713z"></path>
    </svg>
    `
};